export const esgCoveragePercentagesParser = data =>
  data
    .filter(v => v.percentage > 0)
    .map(({ continent, companyCount, percentage, continentCode }) => ({
      label: continent,
      total: companyCount,
      percent: Math.round(percentage * 100),
      id: continentCode,
    }));
